var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 2.89543 3.89543 2 5 2H15C16.1046 2 17 2.89543 17 4V11.25H18C19.5188 11.25 20.75 12.4812 20.75 14V15.5C20.75 15.9142 21.0858 16.25 21.5 16.25C21.9142 16.25 22.25 15.9142 22.25 15.5V8.73228C21.4019 8.61097 20.75 7.88162 20.75 7V5.81066L19.4697 4.53033C19.1768 4.23744 19.1768 3.76256 19.4697 3.46967C19.7626 3.17678 20.2374 3.17678 20.5303 3.46967L22.9445 5.88388C23.4603 6.39961 23.75 7.09908 23.75 7.82843V15.5C23.75 16.7426 22.7426 17.75 21.5 17.75C20.2574 17.75 19.25 16.7426 19.25 15.5V14C19.25 13.3096 18.6904 12.75 18 12.75H17V21.25H18C18.4142 21.25 18.75 21.5858 18.75 22C18.75 22.4142 18.4142 22.75 18 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H3V4ZM5 5V10C5 10.5523 5.44772 11 6 11H14C14.5523 11 15 10.5523 15 10V5C15 4.44772 14.5523 4 14 4H6C5.44772 4 5 4.44772 5 5ZM7 14.25C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H13C13.4142 15.75 13.75 15.4142 13.75 15C13.75 14.5858 13.4142 14.25 13 14.25H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.212ac125d5d7a345fc0ae4305540ab64.svg";
export { ForwardRef as ReactComponent };